
import { Map, MessageCircle, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { buildWhatsAppUrl, GENERAL_WHATSAPP_MESSAGE } from '@/utils/whatsapp';

const GOOGLE_MAPS_LINK = 'https://maps.app.goo.gl/NM3LVKEpgNXcQ9C48?g_st=awb';
const WHATSAPP_LINK = buildWhatsAppUrl(GENERAL_WHATSAPP_MESSAGE);

const ContactActionButtons = ({ className = '' }: { className?: string }) => {
  const handleMapClick = () => {
    window.open(GOOGLE_MAPS_LINK, '_blank');
  };

  const handleWhatsAppClick = () => {
    window.open(WHATSAPP_LINK, '_blank');
  };

  return (
    <div className={`flex flex-wrap gap-4 ${className}`}>
      <Button
        onClick={handleMapClick}
        variant="secondary"
        className="group"
        data-gradient="gold"
      >
        <Map
          className="mr-2 group-hover:scale-110 transition-transform"
          size={20}
        />
        Google Maps
      </Button>
      <Button
        onClick={handleWhatsAppClick}
        variant="secondary"
        className="group"
        data-gradient="gold"
      >
        <MessageCircle
          className="mr-2 group-hover:scale-110 transition-transform"
          size={20}
        />
        WhatsApp
      </Button>
      <Link to="/contact">
        <Button
          variant="secondary"
          className="group"
          data-gradient="gold"
        >
          <Mail
            className="mr-2 group-hover:scale-110 transition-transform"
            size={20}
          />
          Email Us
        </Button>
      </Link>
    </div>
  );
};

export default ContactActionButtons;
